import { useTranslation } from "react-i18next";

const FEATURE_IMAGES = [
  "https://readdy.ai/api/search-image?query=digital%20security%20shield%20lock%20icon%20on%20dark%20server%20room%20background%20with%20green%20glowing%20circuits%20and%20network%20data%20streams%2C%20cybersecurity%20concept%2C%20dramatic%20lighting%2C%20high%20tech%20atmosphere%2C%203d%20render%20style%2C%20ultra%20sharp%20detail%2C%20minimal%20dark%20background&width=600&height=400&seq=feat001&orientation=landscape",
  "https://readdy.ai/api/search-image?query=modern%20data%20center%20server%20racks%20with%20blue%20LED%20lights%20glowing%20in%20rows%2C%20cloud%20hosting%20infrastructure%2C%20clean%20minimal%20background%2C%20high%20availability%20uptime%20concept%2C%20professional%20tech%20photography%2C%20cool%20toned%20light%2C%20ultra%20sharp&width=600&height=400&seq=feat002&orientation=landscape",
  "https://readdy.ai/api/search-image?query=email%20envelope%20with%20padlock%20and%20end%20to%20end%20encryption%20visual%2C%20floating%20digital%20message%20with%20shield%20protection%2C%20teal%20and%20dark%20gradient%20background%2C%20modern%20flat%203d%20illustration%20style%2C%20clean%20minimal%20design&width=600&height=400&seq=feat003&orientation=landscape",
  "https://readdy.ai/api/search-image?query=multilingual%20interface%20on%20laptop%20screen%20showing%20Azerbaijani%20Russian%20English%20flags%2C%20modern%20UI%20design%2C%20clean%20workspace%20desk%20setup%2C%20warm%20light%2C%20professional%20photography%2C%20soft%20background%20blur&width=600&height=400&seq=feat004&orientation=landscape",
];

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    { title: t("home.feature1_title"), desc: t("home.feature1_desc"), icon: "ri-id-card-line", img: FEATURE_IMAGES[0] },
    { title: t("home.feature2_title"), desc: t("home.feature2_desc"), icon: "ri-server-line", img: FEATURE_IMAGES[1] },
    { title: t("home.feature3_title"), desc: t("home.feature3_desc"), icon: "ri-lock-2-line", img: FEATURE_IMAGES[2] },
    { title: t("home.feature4_title"), desc: t("home.feature4_desc"), icon: "ri-global-line", img: FEATURE_IMAGES[3] },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-red-600 text-xs font-bold tracking-widest uppercase">{t("home.features_subtitle")}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mt-2">{t("home.features_title")}</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {features.map((f, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              style={{ minHeight: "280px" }}
            >
              <img
                src={f.img}
                alt={f.title}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
              <div className="relative z-10 p-7 h-full flex flex-col justify-end">
                <div className="w-10 h-10 flex items-center justify-center bg-red-600/90 rounded-xl mb-3">
                  <i className={`${f.icon} text-white text-lg`} />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{f.title}</h3>
                <p className="text-sm text-white/75 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
